module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup_box"
  }, [_c('div', {
    staticClass: "sub_update"
  }, [_c('div', {
    staticClass: "update"
  }, [_c('div', {
    staticClass: "update_main"
  }, [_c('div', {
    staticClass: "update_logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "update_title"
  }), _vm._v(" "), _c('div', {
    staticClass: "update_text"
  }, [_c('em', {
    domProps: {
      "innerHTML": _vm._s(_vm.versionInfo.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "update_btn02"
  }, [_c('em', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stopRemind),
      expression: "stopRemind"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.stopRemind) ? _vm._i(_vm.stopRemind, null) > -1 : (_vm.stopRemind)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.stopRemind,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.stopRemind = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.stopRemind = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.stopRemind = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', [_vm._v("以后不再提醒")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/indexUpdate",
      "target": "_blank"
    }
  }, [_vm._v("更新详情")])], 1), _vm._v(" "), _c('div', {
    staticClass: "update_btn"
  }, [_c('span', [_c('a', {
    on: {
      "click": _vm.startUse
    }
  }, [_vm._v("开始使用")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-706c3950","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/UpdateList.vue
// module id = 1565
// module chunks = 0